const searchOption = [
  {
    state: 0,
    text: "제목",
  },
  {
    state: 1,
    text: "내용",
  },
  {
    state: 2,
    text: "제목 및 내용",
  },
];

const timePeriodFilter = [
  {
    state: 0,
    duration: 0,
    text: "오늘",
  },
  {
    state: 1,
    duration: 7,
    text: "1주일",
  },
  {
    state: 2,
    duration: 1,
    text: "1개월",
  },
  {
    state: 3,
    duration: 3,
    text: "3개월",
  },
  {
    state: 4,
    duration: 6,
    text: "6개월",
  },
  {
    state: 5,
    duration: 1,
    text: "1년",
  },
];

export { searchOption, timePeriodFilter };
